import type { Action } from '../../../../types/context-action/action';

export const SUBMISSION_ACTIONS = {
  SUBMIT: 'SUBMIT',
  SIMULATE_SUBMIT: 'SIMULATE_SUBMIT',
  SUBMIT_IN_PROGRESS: 'SUBMIT_IN_PROGRESS',
  SUBMISSION_FAILED: 'SUBMISSION_FAILED',
  PROCESSING_IN_PROGRESS: 'PROCESSING_IN_PROGRESS',
  TOGGLE_TOS_CHECKBOX: 'TOGGLE_TOS_CHECKBOX',
} as const;

export type SubmitAction = Action<typeof SUBMISSION_ACTIONS.SUBMIT>;

export type SimulateSubmitAction = Action<
  typeof SUBMISSION_ACTIONS.SIMULATE_SUBMIT
>;

export type SubmitInProgressAction = Action<
  typeof SUBMISSION_ACTIONS.SUBMIT_IN_PROGRESS
>;

export type SubmissionFailedAction = Action<
  typeof SUBMISSION_ACTIONS.SUBMISSION_FAILED
>;

export type ProcessingInProgressAction = Action<
  typeof SUBMISSION_ACTIONS.PROCESSING_IN_PROGRESS
>;

export type ToggleTosCheckboxAction = Action<
  typeof SUBMISSION_ACTIONS.TOGGLE_TOS_CHECKBOX
>;

export type SubmissionAction =
  | SubmitAction
  | SimulateSubmitAction
  | SubmitInProgressAction
  | SubmissionFailedAction
  | ProcessingInProgressAction
  | ToggleTosCheckboxAction;
